import { createAction, createSlice } from "@reduxjs/toolkit";

const getDetailOrderSlice = createSlice({
  name: "getDetailOrder",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getDetailOrderSlice;
const getDetailOrderAction = createAction(name);

export {
  getDetailOrderAction,
  actions as getDetailOrderActions,
  reducer as getDetailOrderReducer,
};
